import { Component } from 'react'
import * as PropTypes from 'prop-types'

export default class AppUnAuthed extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  componentDidMount() {
    this.onMount(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.onMount(nextProps)
  }

  onMount = props => {
    if (props.token && props.userId) {
      const url = window._originalPathname + window._originalHash
      window._originalPathname = undefined
      window._originalHash = undefined
      props.goTo(url || '/dashboard')
    }
  }

  render() {
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/AppUnAuthed/AppUnAuthed.js